const firebaseCredentials = {
    apiKey: "AIzaSyBgHLzqOBsx0grmwigTiMgpCBsOUCxDLUI",
    authDomain: "rj-mapa-realizacoes.firebaseapp.com",
    projectId: "rj-mapa-realizacoes",
    storageBucket: "rj-mapa-realizacoes.appspot.com",
    messagingSenderId: "413607546188",
    appId: "1:413607546188:web:b869d6cd04cca0e80213e9"
};

export default firebaseCredentials;